module.exports = __webpack_public_path__ + "Lato-Black.f80bda6afd1953436844.woff";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/Lato/fonts/Lato-Black.woff
// module id = ../../../../../src/assets/fonts/Lato/fonts/Lato-Black.woff
// module chunks = styles